import { getAdmins, SaveApiResMessage } from '@/actions';
import React, { useState } from 'react';
import List from './List';
import styles from './styles';
import { useNotify } from 'react-admin';
import Pagination from '@/components/pagination';
import LoadingV2 from '@/components/Loading';

export default () => {
  const cls = styles();
  const [loading, setLoading] = useState(false);
  const [admins, setAdmins] = React.useState({
    loading: false,
    DATA: [],
  });
  const [form, setForm] = React.useState(null);
  const [filter, setFilter] = React.useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pages: [1],
  });
  const notify = useNotify();

  const createArrayFromNumbers = (number) => {
    let numberArray = [];
    for (let i = 1; i <= number; i++) {
      numberArray.push(i);
    }

    return numberArray;
  };

  const getAdminsList = () => {
    setAdmins((prev) => {
      return {
        ...prev,
        loading: true,
      };
    });
    getAdmins(
      form
        ? { ...form, page: pagination.currentPage }
        : { page: pagination.currentPage }
    )
      .then((res) => {
        let DATA = res.data;
        setAdmins((prev) => {
          return {
            loading: false,
            DATA: DATA,
          };
        });
        setPagination((prev) => {
          return {
            ...prev,
            pages: createArrayFromNumbers(Math.ceil(res.total / res.per_page)),
          };
        });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({ title: 'Error', message: err, mode: 'warning' });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    setLoading(true);
    getAdminsList();
  }, [notify, pagination.currentPage, form]);

  return (
    <div className={cls.membersMainContainer}>
      {loading ? (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      ) : (
        <>
          <List
            filter={filter}
            setFilter={setFilter}
            setFilterForm={setForm}
            setDATA={setAdmins}
            getAdmins={getAdminsList}
            DATA={admins.DATA}
            notify={notify}
            setLoading={setLoading}
          />
          <Pagination pagination={pagination} setPagination={setPagination} />
        </>
      )}
    </div>
  );
};
